import { IUserToken } from '@module/authentication/models';
import download from 'downloadjs';

const baseUrl = `${environmentSettings.webapiUrl}/v1/Download`;
export async function DownloadTemplateFile() {
  const headers = new Headers();
  headers.append('pragma', 'no-cache');
  headers.append('cache-control', 'no-cache');

  const response = await fetch(baseUrl, { headers, cache: 'no-store' });
  if (response.ok) {
    return response;
  } else {
    return Promise.reject(`System error: ${response.status} ${response.statusText}`);
  }
}

export async function DownloadReport(sparePartsUploadDetailsID: string, sparePartsUploadID: string, requestID: number): Promise<any> {
  const url = `${baseUrl}/RequestSummaryReport/${sparePartsUploadDetailsID}/${sparePartsUploadID}`;

  const headers = new Headers();
  headers.append('pragma', 'no-cache');
  headers.append('cache-control', 'no-cache');
  headers.append('Content-Type', 'application/json');
  headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');

  const response = await fetch(url, { headers, method: 'GET', cache: 'no-store' });         
  if (!response.ok) {
    return Promise.reject(`System error: ${response.status} ${response.statusText}`);
  } else {            
    const blob = await response.blob();                
    download(blob, `Request_Summary_Report_${requestID}.xlsx`); 
  }
}
